/*

    master-objects.js

    These "master" objects will be used throughout the app.
    The entire objects are writable Svelte stores.

        masterTaxonomies - copy all others from this
        masterSearch
        masterService
        masterCreateService
        masterUpdateService
        masterReview                // new 8/18

    Note the use of get() to access the stores.
    
*/


import TaxonomiesObject from './taxonomy-classes.js';
import { writable, get } from 'svelte/store';
import { SearchObject, ServiceObject, ReviewObject } from './connect-classes.js';
import { fetchTaxonomies2, publicFetchTaxonomies2} from '../api/services.ts';
import { setErrorAlert } from '../stores/AlertsStore';

// these will persist throughout the app
export const masterTaxonomies = writable(new TaxonomiesObject());
export const masterSearch = writable(new SearchObject('masterSearch'));
export const masterService = writable(new ServiceObject('masterService'));
export const masterCreateService = writable(new ServiceObject('masterCreateService'));
export const masterUpdateService = writable(new ServiceObject('masterUpdateService'));

// not a Svelte store - leftService and rightService are stores
export const masterReview = new ReviewObject('masterReview');

// UTILITY FUNCTIONS

// api data fetched once and copied into the master objects
const copyTaxonomiesToMasterObjects = () => {
    //console.log('master-objects copyTaxonomiesToMasterObjects');
    
    get(masterSearch).copyTaxonomies(get(masterTaxonomies));
    get(masterService).copyTaxonomies(get(masterTaxonomies));
    get(masterCreateService).copyTaxonomies(get(masterTaxonomies));
    get(masterUpdateService).copyTaxonomies(get(masterTaxonomies));

    // using the new masterReview object
    get(masterReview.leftServiceObj).copyTaxonomies(get(masterTaxonomies));
    get(masterReview.rightServiceObj).copyTaxonomies(get(masterTaxonomies));

    // TODO: are these next lines needed to trigger refresh ???
    masterSearch.set(get(masterSearch));
    masterService.set(get(masterService));
    masterCreateService.set(get(masterCreateService));
    masterUpdateService.set(get(masterUpdateService));

}


// called at <App> refresh
export const loadTaxonomies = async (isPublic = false) => {
    //console.log('master-objects loadTaxonomies');

    let resp = null;
    let apiData = null;

    if (isPublic) {
        resp = await publicFetchTaxonomies2();
    } else {
        resp = await fetchTaxonomies2();
    }

    if (resp.errors) {
        setErrorAlert('Error while fetching taxonomies', 2000);
        return null;
    }

    apiData = resp;
    // console.log('master-objects loadTaxonomies completed OK:');
    // console.log(apiData);

    get(masterTaxonomies).initTaxonomies(apiData);      // set once at startup - creates "first-child" node!
    copyTaxonomiesToMasterObjects();

    return apiData;
}


// call before navigating to ResourceExplorer via Menu or Tile
export const clearMasterSearch =  () => {
    // console.log('clearMasterSearch');
    get(masterSearch).selectAllNodes(false);
    get(masterSearch).text = '';
    get(masterSearch).postalResults = [];
    get(masterSearch).filterResults = [];
    get(masterSearch).location.postalCode = '';
    // console.log(get(masterSearch));
}
